

















import captcha from "./captacha";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Captcha extends Vue
{
    /**
     * 验证码图片
     */
    protected getCaptchaImg(): string
    {
        // todo
        return `https://api.healthforce.cc/verifyImgs/Pic${Math.round(Math.random()*10)}.jpg`;
    }

    /**
     * 钩子
     */
    created()
    {
        let self: any = this;
        captcha({
            id: "captcha",
            isRemoteVerify: true,
            setSrc: () => self.getCaptchaImg(),
            onSuccess: function (trail: Array<number>) {  //成功事件
                var handler = setTimeout(()=> {
                    window.clearTimeout(handler);
                    self.$emit("verifySuccess", trail);
                }, 100);
            },
            onClose: function () { //关闭验证码窗口
                var closeHandle = setTimeout(()=> {
                    window.clearTimeout(closeHandle);
                    self.$emit("closeCaptcha");
                }, 100);
            }
        });
    }
}
